import React from 'react'


const Empty = ({ className, title }) => (
    <div className={ `Objects__Empty ${className}` }>{ title }</div>
)

export default Empty